import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { createElement } from "react"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Safety limit to prevent ReDoS with too many alternations in the regex.
// If exceeded, highlighting is silently skipped and raw text is returned.
const MAX_KEYWORDS = 20;

export function highlightKeywords(text: string, keywords: string[], className: string = "text-gold") {
  if (keywords.length === 0 || !text) return [text];
  if (keywords.length > MAX_KEYWORDS) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[highlightKeywords] ${keywords.length} keywords exceeds MAX_KEYWORDS (${MAX_KEYWORDS}). Highlighting skipped.`);
    }
    return [text];
  }
  const regex = new RegExp(`(${keywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');
  const parts = text.split(regex);
  const lowerKeywords = keywords.map(k => k.toLowerCase());
  return parts.map((part, i) =>
    lowerKeywords.includes(part.toLowerCase())
      ? createElement("span", { key: i, className }, part)
      : part
  );
}

export function ensureStringArray(value: unknown): string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string')
    ? (value as string[])
    : [];
}
